import { useEffect } from 'react';

export const useTheme = () => {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('dark');
    localStorage.setItem('theme', 'light');
  }, []);

  return { theme: 'light', toggleTheme: () => {} };
};